export default __webpack_public_path__ + "static/media/CodersCruxRegular.7867e66d.woff";